import links from '../../../routes/links'

const forms = [
  {
    label: 'Leave Request',
    subheader: 'Indo Team',
    link: links.public.leaveRequestIndoTeam(),
    bannerUrl:
      'https://firebasestorage.googleapis.com/v0/b/astute-curve-472508-n6.firebasestorage.app/o/banners%2Findonesia-banner.webp?alt=media&token=18dc51a7-58a4-4d62-9f4d-a5804fa97f44',
  },
  {
    label: 'Leave Request',
    subheader: 'Japan Team',
    link: links.public.leaveRequestJapanTeam(),
    bannerUrl:
      'https://firebasestorage.googleapis.com/v0/b/astute-curve-472508-n6.firebasestorage.app/o/banners%2Fjapan-banner.jpg?alt=media&token=5cf992af-d0d0-4aeb-9604-8213dadd988d',
  },
  {
    label: 'Medical Reimbursement',
    subheader: 'All Team',
    link: links.public.medicalReimbursement(),
    bannerUrl:
      'https://firebasestorage.googleapis.com/v0/b/astute-curve-472508-n6.firebasestorage.app/o/banners%2Fmedical-banner.jpg?alt=media&token=4833e228-a3aa-4ed7-9276-d89f8af2e8a5',
  },
]

export default forms
